exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overall-performance[data-v-8a5548d8]{background-color:#b2b9cb}.result[data-v-8a5548d8]{background-color:#ccd1dd}", ""]);

// exports
